import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { FormationCard } from '../components/FormationCard';
import { Cap360 } from '../components/Cap360';
import { CTABand } from '../components/CTABand';
import { ContactCTA } from '../components/ContactCTA';
import { useSeo } from '../hooks/useSeo';
import { FORMATIONS } from '../data/constants';
import { Info } from 'lucide-react';
import { Alert, AlertDescription } from '../components/ui/Alert';
export function FormationsList() {
  useSeo({
    title: 'Formations en alternance dans le commerce — Joigny, Yonne',
    description: 'BTS NDRC, TP Conseiller de Vente et TP Négociateur Technico-Commercial en alternance à Joigny (89). Formations gratuites pour l’apprenti, rentrée en formation le 25 septembre 2026, places limitées.',
    path: '/formations'
  });
  return <div className="flex flex-col w-full" data-id="element-1957" data-mp="2nm11lqlny8ip">
      <PageHeader title="Nos Formations en Alternance" subtitle="Découvrez nos parcours diplômants dans les domaines du commerce, de la vente et de la relation client." data-id="element-1958" data-mp="2iorbs9ud3uuc" />

      <div className="py-24 bg-muted relative overflow-hidden" data-id="element-1959" data-mp="2pd69te3x1rif">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1960" data-mp="2pbcznou3gp5o" />
        <div className="container relative z-10" data-id="element-1961" data-mp="2zb3uxsqhb86t">
          <div className="max-w-4xl mx-auto mb-20" data-id="element-1962" data-mp="2zau3e0pscsz0">
            <Alert className="bg-white border-none shadow-xl p-8 rounded-3xl flex items-center gap-6 group hover:-translate-y-1 transition-transform" data-id="element-1963" data-mp="21nvam127s56e">
              <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1964" data-mp="26my912novd5e">
                <Info className="h-8 w-8 text-brand-orange animate-soft-bounce" data-id="element-1965" data-mp="2gczynyvox3mf" />
              </div>
              <AlertDescription className="text-xl text-primary-dark font-extrabold leading-relaxed" data-id="element-1966" data-mp="1ixm2kajqxj6s">
                Zillenium Alternance présente uniquement les formations ouvertes
                sur des sessions confirmées.
              </AlertDescription>
            </Alert>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto items-start" data-id="element-1967" data-mp="1bufilhcxuuwb">
            {[...FORMATIONS].sort((a, b) => (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0)).map(formation => <div key={formation.id} className={formation.isNew ? 'md:col-span-2' : ''} data-id="element-1968" data-mp="1kn943wizaqim">
                  <FormationCard formation={formation} data-id="element-1969" data-mp="wygcgc9e34tt" />
                </div>)}
          </div>

          <div className="mt-12 max-w-3xl mx-auto" data-id="element-1970" data-mp="16ut7bdgo7oq5">
            <Cap360 data-id="element-1971" data-mp="16vm71uh7pdys" />
          </div>

          <div className="mt-16 max-w-6xl mx-auto" data-id="element-1972" data-mp="16sggsbwuk61h">
            <ContactCTA title="Hésitation entre deux formations ?" subtitle="Appelez-nous : en quelques minutes, nous vous aidons à choisir le parcours le plus adapté à votre projet et à votre profil." action={{
            label: 'Ou candidatez directement',
            to: '/candidater'
          }} data-id="element-1973" data-mp="11uyeh4dc4p2g" />
          </div>
        </div>
      </div>

      <div className="mt-24" data-id="element-1974" data-mp="43ryxgazbph7">
        <CTABand title="Prêt à vous lancer ?" description="Rejoignez Zillenium Alternance et donnez vie à vos projets professionnels." primaryButtonText="Je candidate maintenant" primaryButtonLink="/candidater" secondaryButtonText="Je suis une entreprise" secondaryButtonLink="/entreprises" data-id="element-1975" data-mp="3zug6vsbczxu" />
      </div>
    </div>;
}